import { render, staticRenderFns } from "./EditorAccountNickname.vue?vue&type=template&id=583014f6&scoped=true&"
import script from "./EditorAccountNickname.vue?vue&type=script&lang=js&"
export * from "./EditorAccountNickname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583014f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583014f6')) {
      api.createRecord('583014f6', component.options)
    } else {
      api.reload('583014f6', component.options)
    }
    module.hot.accept("./EditorAccountNickname.vue?vue&type=template&id=583014f6&scoped=true&", function () {
      api.rerender('583014f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorAccountNickname.vue"
export default component.exports